import { Card } from '@/components/ui/card'
import { cva, type VariantProps } from 'class-variance-authority'

const metricValueVariants = cva('text-xl font-extrabold', {
  variants: {
    color: {
      default: 'text-foreground',
      high: 'text-green-600 dark:text-green-400',
      medium: 'text-orange-600 dark:text-orange-400',
      low: 'text-red-600 dark:text-red-400'
    }
  },
  defaultVariants: {
    color: 'default'
  }
})

interface MetricCardProps extends VariantProps<typeof metricValueVariants> {
  label: string
  value: string | number
  subtext?: string
  info?: string
}

export default function MetricCard({
  label,
  value,
  subtext,
  info,
  color
}: MetricCardProps) {
  return (
    <Card className="p-4">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-muted-foreground">
          {label}
        </h4>
        {info && (
          <div className="text-xs text-muted-foreground">
            <span className="cursor-help" title={info}>
              ⓘ
            </span>
          </div>
        )}
      </div>
      <div className={metricValueVariants({ color })}>{value}</div>
      {subtext && (
        <div className="text-xs text-muted-foreground mt-1">
          {subtext}
        </div>
      )}
    </Card>
  )
}